const questionAnswerTypeMap = {
  RawAnswer: ['number', 'textarea', 'text', 'image_upload', 'multiple_image_upload', 'image_capture', 'multiple_image_capture', 'voice_record', 'video_capture'],
  SelectionAnswer: ['checkbox', 'dropdown', 'radio', 'ordering', 'tag'],
  GeoAnswer: ['location_stamp', 'location_map']
};

export default questionAnswerTypeMap;


// WEBPACK FOOTER //
// ./src/constants/task-form/question-answer-type-map.js